import React from "react";
import { motion } from "framer-motion";
import {
  Mic2,
  MessagesSquare,
  Presentation,
  GraduationCap,
  Lightbulb,
  Layers,
  PartyPopper,
  Sparkles,
} from "lucide-react";

const Actividades = () => {
  const activities = [
    {
      title: "Conferencia magistral",
      description:
        "Presentada por experto internacional en educación en línea y educación superior.",
      icon: <Mic2 size={32} />,
      bgIcon: <Mic2 size={180} />,
    },

    {
      title: "Innova docentes ",
      description:
        "Experiencias innovadoras desarrolladas por docentes y estudiantes en educación en línea.",
      icon: <Presentation size={32} />,
      bgIcon: <Presentation size={180} />,
    },

    {
      title: "Debate | 50 años ofertando MAD: transformando vidas y contextos ",
      description:
        "Un espacio para reflexionar sobre el impacto de la Modalidad Abierta y a Distancia en la formación de profesionales y la transformación de vidas durante cinco décadas de trayectoria.",
      icon: <Presentation size={32} />,
      bgIcon: <Presentation size={180} />,
    },

    {
      title: "Summer Camp de Emprendimiento e Innovación",
      description:
        "Estudiantes desarrollan soluciones a retos actuales relacionados con la educación digital.",
      icon: <Lightbulb size={32} />,
      bgIcon: <Lightbulb size={180} />,
    },
    {
      title: "Zonas interactivas",
      description:
        "Espacios para presentar recursos educativos, herramientas digitales y proyectos académicos innovadores.",
      icon: <Layers size={32} />,
      bgIcon: <Layers size={180} />,
    },
    {
      title: "UTPL FEST",
      description:
        "Encuentro especial de integración para la comunidad UTPL.",
      icon: <PartyPopper size={32} />,
      bgIcon: <PartyPopper size={180} />,
    },
    {
      title: "Encuentro Alumni",
      subtitle: "Legado que trasciende",
      description:
        "Testimonios sobre el impacto de la modalidad a distancia en trayectorias personales y profesionales.",
      icon: <GraduationCap size={32} />,
      bgIcon: <GraduationCap size={180} />,
    },

    {
      title: "Ser +  ",
      subtitle: "Historias que trascienden fronteras",
      description:
        "Testimonios de estudiantes que superan barreras físicas y personales para cumplir su sueño profesional, evidenciando el impacto transformador de la educación a distancia de la UTPL.",
      icon: <GraduationCap size={32} />,
      bgIcon: <GraduationCap size={180} />,
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <section className="py-24 bg-[#004270] relative overflow-hidden">
      {/* Estilos para gradientes en iconos */}
      <style>
        {`
          .icon-gradient {
            fill: url(#blueYellowGradient);
            stroke: url(#blueYellowGradient);
            opacity: 0.07;
          }
        `}
      </style>

      {/* Definición de gradiente SVG */}
      <svg width="0" height="0" className="absolute">
        <defs>
          <linearGradient
            id="blueYellowGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop
              offset="0%"
              style={{ stopColor: "#004270", stopOpacity: 1 }}
            />
            <stop
              offset="100%"
              style={{ stopColor: "#febe10", stopOpacity: 1 }}
            />
          </linearGradient>
        </defs>
      </svg>

      {/* Decoración ambiental de la sección */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute top-10 right-10 w-64 h-64 bg-[#febe10]/10 rounded-full blur-[100px]"></div>
        <div className="absolute bottom-10 left-10 w-96 h-96 bg-white/5 rounded-full blur-[120px]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Cabecera */}
        <div className="text-center  mb-6 space-y-4">
          <motion.h2
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-white"
          >
            Actividades  principales 
          </motion.h2>
           
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="flex flex-wrap justify-center items-stretch gap-6"
        >
          {activities.map((activity, index) => (
            <div
              key={`${activity.title}-${index}`}
              className="basis-full sm:basis-[calc(50%-12px)] lg:basis-[calc(30%-18px)] flex"
            >
              <motion.div
                variants={itemVariants}
                whileHover={{ y: -8 }}
                className="relative group bg-white p-8 rounded-[3rem] shadow-xl overflow-hidden flex flex-col w-full transition-all duration-500"
              >
                {/* Icono de Fondo */}
                <div className="absolute -bottom-10 -right-10 rotate-12 group-hover:rotate-0 group-hover:scale-110 transition-transform duration-700 pointer-events-none">
                  {React.cloneElement(activity.bgIcon, {
                    className: "icon-gradient",
                  })}
                </div>

                {/* Icono */}
                <div className="relative z-10">
                  <div className="w-16 h-16 rounded-2xl bg-[#004270] flex items-center justify-center text-[#febe10] mb-8 shadow-lg shadow-blue-900/20 group-hover:bg-[#febe10] group-hover:text-[#004270] transition-colors duration-300">
                    {activity.icon}
                  </div>

                  <h4  > {activity.title}

                    {activity.subtitle && (
                      <span className="block text-sm font-bold text-[#febe10] uppercase tracking-widest mt-2">
                        {activity.subtitle}
                      </span>
                    )}
                  </h4>
                </div>

                {/* Descripción */}
                <div className="relative z-10 flex-1">
                  <p  >
                    {activity.description}
                  </p>
                </div>

                {/* Línea inferior */}
                <div className="relative z-10 mt-8 pt-6 border-t border-slate-100">
                  <div className="w-10 h-1 bg-[#febe10] rounded-full group-hover:w-20 transition-all duration-500"></div>
                </div>
              </motion.div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Actividades;
